import { z } from "zod";

export const WorkspaceRoleSchema = z.enum(["Owner", "Admin", "Creator", "Viewer", "Billing", "Guest", "Contributor"]);

export type WorkspaceRole = z.infer<typeof WorkspaceRoleSchema>;
export const WorkspaceRole = WorkspaceRoleSchema.enum;
